/* eslint-disable react/require-default-props */

import React, { useMemo, useState } from 'react';

import Model from '@tripian/model';

import Gmap from '../../components/Gmap/GMap';
import MapSearch from './MapSearch/MapSearch';
import CurrentLocation from './CurrentLocation/CurrentLocation';
import ShowAllAlternatives from './ShowAllAlternatives/ShowAllAlternatives';

import config from '../../../../config';
import './MapLayout.scss';

interface IMapLayout {
  planDayIndex: number;
  fullWidth: boolean;
  alternativesStepId?: number;
  poiCategories: Model.PoiCategory[];
}

const MapLayout: React.FC<IMapLayout> = ({ planDayIndex, fullWidth, alternativesStepId, poiCategories }) => {
  // const day = useSelector((state: ICombinedState) => state.trip.day);

  const [showAllalternatives, setShowAllalternatives] = useState(false);
  const [searchThisAreaPois, setSearchThisAreaPois] = useState<Model.Poi[]>([]);

  // useEffect(() => {
  //   setShowAllalternatives(false);
  // }, [day]);

  const mapClasses = ['map-container'];
  if (config.HIDE_OVERVIEW) mapClasses.push('container-height');
  else mapClasses.push('container-height-tab');
  if (fullWidth) mapClasses.push('w-m-100');

  const googleMap = useMemo(() => <Gmap planDayIndex={planDayIndex} showAllalternatives={showAllalternatives} alternativesStepId={alternativesStepId} searchThisAreaPois={searchThisAreaPois} />, [
    alternativesStepId,
    planDayIndex,
    searchThisAreaPois,
    showAllalternatives,
  ]);

  return (
    <div className={mapClasses.join(' ')}>
      {googleMap}
      <MapSearch show setSearchThisAreaPois={setSearchThisAreaPois} poiCategories={poiCategories} />
      <CurrentLocation />
      <ShowAllAlternatives show={showAllalternatives} setShow={setShowAllalternatives} />
    </div>
  );
};

export default MapLayout;
